// extracted by mini-css-extract-plugin
export default {"output":"DataOutputsFieldset-styles-module--output--Hep6h"};